// src/components/layout/OnlineBar.tsx
import { useSelector } from 'react-redux';
import { Landmark, ClipboardList } from 'lucide-react';
import { RootState } from 'store';

export default function OnlineBar() {
  const { onlineUsers } = useSelector((s: RootState) => s.ui);

  if (onlineUsers.length < 2) return null;

  return (
    <div className="flex items-center gap-2.5 px-4 py-2 bg-green-600/10 border-b border-green-600/25 flex-wrap">
      <span className="flex items-center gap-1.5 text-sm font-extrabold text-green-700">
        <span className="w-2 h-2 rounded-full bg-green-600 animate-pulse" />
        Online
      </span>
      <div className="flex items-center gap-1.5 flex-wrap">
        {onlineUsers.map((u, i) => (
          <span key={i} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-green-600 text-white text-[13px] font-bold shadow-sm">
            {u.role === 'officer' ? <Landmark className="w-3.5 h-3.5" strokeWidth={2} /> : <ClipboardList className="w-3.5 h-3.5" strokeWidth={2} />}
            {u.role === 'officer' ? 'Officer' : 'PA'}
          </span>
        ))}
      </div>
    </div>
  );
}
